import { AnimatePresence, motion } from 'motion/react';
import { COLLAPSE_ANIMATION } from './animated-collapse-constants';

interface AnimatedCollapseProps {
  open: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * Smooth height + opacity transition for expand/collapse content.
 * Animates from height:0 to auto on mount and back on unmount via
 * `AnimatePresence`. Use wherever you'd otherwise do manual conditional
 * rendering for accordion-style disclosure.
 */
export function AnimatedCollapse({ open, children, className }: AnimatedCollapseProps) {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: COLLAPSE_ANIMATION.duration, ease: COLLAPSE_ANIMATION.ease }}
          style={{ overflow: 'hidden' }}
          className={className}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
